import React from "react";
import WSProgressBar from "../../Workspace2/WSProgressBar";
import "../../Workspace2/sidebar.css";
import Button from "@mui/material/Button";
// import FormHelperText from "@mui/material/FormHelperText";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import AddIcon from "@mui/icons-material/Add";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import { Box, InputLabel, Modal } from "@mui/material";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import MiscellaneousServicesIcon from '@mui/icons-material/MiscellaneousServices';
import DoDisturbOnIcon from '@mui/icons-material/DoDisturbOn';
import Loader from "../../../helper/loader";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useHistory, useLocation } from "react-router";
import {
  CreateAccess,
  GetAccess,
  GetUser,
  UpdateStepStatus,
  getMemberForFreePlans,
  getChildUser,
  getworkspaceteamMember,
  getMemberbyPreparerId,
  addworkspaceteamMember,
  deleteworkspaceteamMember,
  getWorkspace,
  getActivePlan
} from "../ApiServices/apiHandler";
import { useEffect } from "react";
import { useState } from "react";
import "../../../WorkSpace/font.css";
import WorkspaceHeader from "./WorkspaceHeader";
import swal from "sweetalert";
import { socket } from '../../../services/socket/socket';
import { motion } from "framer-motion";

import commoncss from "../../../myfin_v2/css/common.module.css"
import buttoncss from "../../../myfin_v2/css/button.module.css"
import wsCreationcss from "../../../myfin_v2/css/workspaceCreation.module.css"
import { ReactComponent as RightIcon } from "../../../myfin_v2/assets/icons/rightWhite.svg";
import { ReactComponent as PervBtnIcon } from '../../../myfin_v2/assets/icons/pervECLBtnIcon.svg'
import { ReactComponent as SearchIcon } from '../../../myfin_v2/assets/icons/search.svg'
import { ReactComponent as DefaultUserIcon } from '../../../myfin_v2/assets/icons/user_round.svg'
import { ReactComponent as CloseIcon } from '../../../myfin_v2/assets/icons/close_grey.svg'


const stylemodal = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 5,
};

const InviteteamMember = (props) => {
  const location = useLocation();
  let a = location.pathname;
  let w_id = a.split("/");
  let history = useHistory();
  const [alluser, setAllUSer] = useState([]);
  const [allmember, setAllmember] = useState([]);
  // const[user,setUser]=useState([]);
  // const [selectedUsers,setSelectedUsers]=useState([]);
  const [userId, setUserId] = useState({});
  const [userAccess, setUserAcces] = useState([]);
  const [openModal, setOpenModal] = React.useState(false);
  const [openModal1, setOpenModal1] = React.useState(false);
  const [openModal2, setOpenModal2] = React.useState(false);
  const [approvalId, setApprovalId] = useState([]);
  const [approverId, setApproverId] = useState({});
  const [reason, setReason] = useState('');
  const [teamMember, setTeamMember] = useState({});
  const [workspace, setWorkspace] = useState({});
  const [ActivePlan, setActivePlan] = useState("");

  const users = JSON.parse(localStorage.getItem('user'));

  useEffect(() => {
    getUser();
    usersData();
    getAllAccess();
    getApprovalIds();
    getworkspaceteamMembers();
    getWorkspaceDetails();
    activePlan();
    if (w_id.includes('inviteteammember')) {
      localStorage.setItem("modifyAccess", 'inviteteammember');
    }
  }, []);


  const handleOpenModal = () => setOpenModal(true);
  const handleCloseModal = () => setOpenModal(false);
  const handleOpenModal1 = () => setOpenModal1(true);
  const handleCloseModal1 = () => setOpenModal1(false);
  const handleOpenModal2 = () => setOpenModal2(true);
  const handleCloseModal2 = () => setOpenModal2(false);

  const getUser = async () => {
    const res = await GetUser();
    if (res.status === 200) {
      setAllUSer(res.data.fetchUser);
    }
  };

  const getAllAccess = async () => {
    const result = await GetAccess();
    if (result.status === 200) {
      console.log(result, "eeeee");
      setUserAcces(result.data.getAccess);
    }
  };

  const getworkspaceteamMembers = () => {
    const workspace_id = w_id[2];
    getworkspaceteamMember(workspace_id)
      .then((result) => {
        if (result.status === 200) {
          setTeamMember(result.data.response?.user_ids);
        }
      })
      .catch(error => {
        swal("Error", "Get Workspace Team Failed", "error")
      });
  };

  const getWorkspaceDetails = async () => {
    const res = await getWorkspace(w_id[2]);
    if (res.status === 200) {
      setWorkspace(res.data?.getworkspace[0])
    }
  }

  //current active plan Subscribed
  const activePlan = async () => {
    try {
      const res = await getActivePlan();
      setActivePlan(res.data.plan_name);
    } catch (error) {
      console.log(error.message)
    }
  }


  const nextStep = async () => {
    try {
      let data = {}
      if (users.responsibilities === "preparer") {
        data = {
          steps: "step6",
          has_published: "draft",
          status: "waiting",
          approver_id: approverId,
          cancel_reason: ""
        };
      } else {
        data = {
          steps: "step6",
          has_published: "published",
          status: "approved",
        };
      }
      const res = await UpdateStepStatus(w_id[2], data);
      if (res.status === 200) {
        setOpenModal(false);
        getWorkspaceDetails();
        if (users.isAdmin === "Yes") {
          history.push(`/overview/${w_id[2]}`);
        }
        if (users.responsibilities === "preparer") {
          socket.emit("add-notification", {
            receiver_id: approverId,
            description: "creation of workspace",
            type: "sent approval",
            path: "/Notification"
          });
          socket.emit('get-notification');
          swal("Success", "Your approval request has been sent successfully", "success")
        }
      }
    }
    catch (error) {
      console.log("error", error.message);
      return 0;
    }
  };
  const skipNext = async () => {

    history.push(`/overview/${w_id[2]}`);
  };

  const handleAdd = () => {
    if (ActivePlan === "Free Plan") {
      swal("Warning", "Upgrade your subscription plan to add team members", "warning");
      return false;
    }
    const datas = {
      workspace_id: w_id[2],
      user_id: userId
    };
    addworkspaceteamMember(datas).then(res => {
      setUserId('');
      getworkspaceteamMembers();
      if (res.data.response.user_exists === true) {
        swal("ERROR", "Team member Already exists", "error");
      } else {
        swal("Success", "Team Added Sucessfully", "success");
      }

    }).catch(error => {
      swal("Error", error.response.data.error || "Workspace Team creation Failed", "error")
    });
  };

  const handleRemove = (u_id) => {
    if (ActivePlan === "Free Plan") {
      swal("Warning", "Upgrade Your Subscripsion plan to remove Team member", "warning");
      return false;
    }
    const datas = {
      workspace_id: w_id[2],
      user_id: u_id
    };
    deleteworkspaceteamMember(datas).then(res => {
      swal("Success", "Team member Removed Sucessfully", "success");
      getworkspaceteamMembers();
    }).catch(error => {
      swal("Error", error.response.data.error || "Workspace Team creation Failed", "error")
    });
  };

  const usersData = async () => {
    if (users.responsibilities === "preparer") {
      const parent_id = users.parent_id;
      const res = await getMemberbyPreparerId(parent_id);
      setAllmember(res.data.mergedData);
    } else {
      const res = await getMemberForFreePlans();
      setAllmember(res.data.fetchMember);
    }
  };

  const handleChange = (event, value) => {
    const newValue = event.target.value;
    setUserId(newValue);
  }

  const handleApproverChange = (event) => {
    const newValue = event.target.value;
    setApproverId(newValue);
  };
  const handleApprove = async () => {
    const data = {
      status: "approved",
      cancel_reason: "",
      has_published: "published",
      steps: "step6",
      approver_id: workspace.approver_id,
    };
    const response = await UpdateStepStatus(w_id[2], data);
    if (response.status === 200) {
      const datas = {
        workspace_id: w_id[2],
        user_id: workspace.approver_id
      };
      addworkspaceteamMember(datas).then(res => {
        swal("Success", "Team Added Sucessfully", "success");
        getworkspaceteamMembers();
      }).catch(error => {
        swal("Error", error.response.data.error, "error")
      });
      swal("Success", "Approved Successfully", "success")
      getWorkspaceDetails();
      socket.emit("add-notification", {
        receiver_id: workspace.user_id,
        description: "workspace",
        type: "approved",
        path: "/Notification"
      });
      socket.emit('get-notification');
    }
  }
  const handleCancel = async () => {
    const data = {
      status: "cancelled",
      cancel_reason: reason,
      has_published: "draft",
      steps: "step6",
      approver_id: workspace.approver_id,
    };
    const response = await UpdateStepStatus(w_id[2], data);
    if (response.status === 200) {
      setOpenModal1(false);
      setReason("");
      swal("Warning", "Cancelled Successfully", "warning")
      getWorkspaceDetails();
      socket.emit("add-notification", {
        receiver_id: workspace.user_id,
        description: "workspace",
        type: "Cancelled",
        path: "/Notification"
      });
      socket.emit('get-notification');
    }
  }
  const getApprovalIds = async () => {
    const parent_id = users.parent_id;
    const workspace_id = w_id[2];
    getChildUser(parent_id, workspace_id)
      .then(response => {
        setApprovalId(response.data.result);
      })
      .catch(error => {
        console.error('Error:', error);
      });
  }
  // modify access function
  const modifyAccessButton = (data) => {
    if (ActivePlan === "Free Plan") {
      swal("Warning", "Upgrade Your Subscripsion plan to Modify Access", "warning");
      return false;
    }
    if (data.responsibilities === "approver" || data.responsibilities === "view") {
      history.push(`/functionalityacess/${data._id}/${w_id[2]}`)
    } else {
      history.push(`/modifyacess/${data._id}/${w_id[2]}`)
    }
  }

  return (
    <>
      <div className={`ml-0 mr-0 ${commoncss.dFlexClm}`}>
        <div>
          <WSProgressBar activePage={6} id={w_id[2]} />
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.5, ease: "easeInOut" }} className={wsCreationcss.wsContentDiv}>
          <span className={`${wsCreationcss.wsContentHeading} text-center mt-5 mb-3`}>
            One last step! Invite your team to join the workspace.
          </span>
          <div className={`${wsCreationcss.addTeamDiv} mt-4`} >
            <div className={commoncss.dFlexJustifysb}>
              <div style={{ "width": "67%" }}>
                <FormControl fullWidth>
                  <Select
                    labelId="demo-simple-select-label"
                    id="demo-simple-select"
                    value={userId || ''}
                    onChange={handleChange}
                    disabled={users.responsibilities === "approver" || users.responsibilities === "view"}
                    classes={{ root: wsCreationcss.selectRoot }}
                    sx={{
                      backgroundColor: '#F4FAF5',
                      color: '#183930',
                      border: '1px solid #ffffff',
                      borderRadius: '6px',
                      '& .MuiSelect-select': {
                        backgroundColor: '#F4FAF5',
                        color: '#183930',
                        border: '1px solid #ffffff',
                        height: '15px',
                        padding: '6px 8px'
                      }
                    }}
                  >
                    {allmember && allmember.length > 0 && allmember.map((data) =>
                      <MenuItem
                        key={data._id}
                        value={data._id}
                        className={wsCreationcss.menuItem}
                      >
                        {data.email} ({data.responsibilities || "admin"})
                      </MenuItem>
                    )}
                  </Select>
                </FormControl>
              </div>
              <div>
                <button
                  style={{
                    textTransform: "none",
                    padding: "5px",
                    fontSize: "14px",
                    fontWeight: "200"
                  }}
                  className={wsCreationcss.saveBtn}
                  disabled={users.responsibilities === "approver" || users.responsibilities === "view"}
                  onClick={handleAdd}
                >
                  <AddIcon />
                  <span className="font-sans">Add into Workspace</span>
                </button>
              </div>
            </div>
            <div className={`${wsCreationcss.addedTeamDiv} mt-2`} >
              {teamMember && teamMember.length > 0 && teamMember.map((data, index) => {
                return (
                  <div className={`${commoncss.dFlexJustifysb}`} style={{ "width": "100%", "margin-bottom": "15px" }}>
                    <div className="d-flex" style={{ "align-items": "center" }}>
                      <span className="mr-2"><DefaultUserIcon /></span>
                      <div className={commoncss.dFlexClm}>
                        <span className={wsCreationcss.wscLabel2}>
                          {data.name ? data.name : "Unknown"}
                        </span>
                        <span className={wsCreationcss.wscLabel10}>
                          {data.email}
                        </span>
                      </div>
                    </div>
                    <div className={commoncss.dFlex} style={{ "gap": "20px" }}>
                      <span className={wsCreationcss.wscLabel6}>{data.isAdmin === "No" ? "User" : "Admin"}</span>
                      <span className={`${wsCreationcss.wscLabel7} ${commoncss.clickable} ml-3`} onClick={() => modifyAccessButton(data)}>Modify Access</span>
                      <span className={`${commoncss.clickable} ml-3`} onClick={
                        users.responsibilities === "approver" || users.responsibilities === "view" ? null :
                          () => handleRemove(data._id)}><CloseIcon /></span>
                    </div>
                  </div>
                )
              }
              )}


              <TableContainer hidden>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                  <TableHead>
                    <TableRow style={{ backgroundColor: "#b5b3b3" }}>
                      <TableCell style={{ border: "none" }} align="center" className="font-sans">S.No</TableCell>
                      <TableCell style={{ border: "none" }} align="center" className="font-sans">Name</TableCell>
                      <TableCell style={{ border: "none" }} align="center" className="font-sans">Company</TableCell>
                      <TableCell style={{ border: "none" }} align="center" className="font-sans">Actions</TableCell>
                      <TableCell style={{ border: "none" }} align="center" className="font-sans">ID</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {teamMember && teamMember.length > 0 && teamMember.map((data, index) =>
                      <TableRow>
                        <TableCell component="th" scope="row" style={{ border: "none" }}>{index + 1}</TableCell>
                        <TableCell align="center" style={{ border: "none" }} className="font-sans">{data.name ? data.name : "Unknown"}</TableCell>
                        <TableCell align="center" style={{ border: "none" }}>Not Listed</TableCell>
                        <TableCell align="center" style={{ border: "none" }}>
                          <div className="d-flex flex-row justify-content-center">
                            <div style={{ color: "#03565a", cursor: "pointer" }}
                              onClick={() => modifyAccessButton(data)}>
                              <MiscellaneousServicesIcon /> Modify access
                            </div>
                            <div style={{ color: "#03565a", cursor: "pointer" }} className="ml-3" onClick={
                              users.responsibilities === "approver" || users.responsibilities === "view" ? null :
                                () => handleRemove(data._id)}>
                              <DoDisturbOnIcon />Remove user
                            </div>
                          </div>
                        </TableCell>
                        <TableCell align="center" style={{ border: "none" }} className="font-sans">{data.email}</TableCell>
                      </TableRow>
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {teamMember && teamMember.length > 0 && (
              <div className={`${wsCreationcss.wscLabel7} mt-2 ml-1`}>
                {teamMember.length} Members Selected
              </div>
            )}
          </div>
          <Modal
            open={openModal}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={stylemodal}>
              <FormControl fullWidth>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  value={approverId || ''}
                  onChange={handleApproverChange}
                >
                  {approvalId && approvalId.length > 0 && approvalId.map((data) =>
                    <MenuItem key={data._id} value={data._id}>{data.name}</MenuItem>
                  )}
                </Select>
              </FormControl>
              <div className="d-flex flex-row justify-content-center mt-3 ">
                <Button style={{
                  backgroundColor: "#03565a",
                  color: "white",
                  textTransform: "none",
                  margin: "10px",
                  width: "50%"
                }}
                  className="font-sans"
                  onClick={handleCloseModal}
                >
                  Return
                </Button>
                <Button
                  style={{
                    backgroundColor: "#03565a",
                    color: "white",
                    textTransform: "none",
                    width: "50%",
                    height: "36px",
                    marginTop: "10px"
                  }}
                  onClick={nextStep}
                  disabled={!approverId}
                  className="font-sans"
                >
                  Send for approval
                </Button>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openModal1}
            onClose={handleCloseModal1}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={stylemodal}>
              <div>
                <label className="font-sans">Cancel Reason:</label>
                <textarea
                  className="w-100"
                  value={reason}
                  onChange={(event) => setReason(event.target.value)}
                />
              </div>
              <div className="d-flex  justify-content-center mt-3 ">
                <Button
                  style={{
                    backgroundColor: "#03565a",
                    color: "white",
                    textTransform: "none",
                    width: "50%",
                    marginTop: "10px"
                  }}
                  className="font-sans"
                  onClick={() => handleCancel()}
                >
                  Submit
                </Button>
              </div>
            </Box>
          </Modal>
          <Modal
            open={openModal2}
            onClose={handleCloseModal2}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={stylemodal}>
              <div className="d-flex flex-row-reverse font-sans" onClick={handleCloseModal2} style={{ cursor: "pointer" }}>Close</div>
              <div style={{ maxHeight: "150px", overflowY: "auto" }} className="mt-4">
                {workspace.cancel_reason ?
                  <p className="font-sans">{workspace.cancel_reason}</p> :
                  <center> There are no remarks </center>
                }
              </div>
            </Box>
          </Modal>
        </motion.div>
        <div className={wsCreationcss.footerContainer}>
          <div>
            <button
              onClick={() => history.push(`/dashboard`)}
              className={wsCreationcss.cancelBtn} type="button" style={{ "padding": "7px" }}>Cancel</button>
          </div>
          <div className={wsCreationcss.footerbtnContainer}>
            {users.responsibilities === "preparer" && users?.unrestrictedaccess === false ? (
              <div className={wsCreationcss.footerbtnContainer}>
                <button
                  className={`${wsCreationcss.perviewBtn}`}
                  onClick={handleOpenModal2}
                  type="button" style={{ "padding": "7px" }}>Remark
                </button>
                &nbsp;
                <button
                  disabled={workspace.status === "waiting"}
                  onClick={() => {
                    if (workspace.status === "start") {
                      handleOpenModal()
                    } else if (workspace.status === "cancelled") {
                      handleOpenModal()
                    } else {
                      history.push(`/overview/${w_id[2]}`);
                    }
                  }} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>{workspace.status === "start" ? "Send for Approval" : (workspace.status === "waiting" ? "Already Sent for approval" : workspace.status === "approved" ? "Next Step" : "Update")}</button>
              </div>
            ) : users.responsibilities === "approver" ? (

              <div className={wsCreationcss.footerbtnContainer}>
                {workspace.status === "approved" ? "" :
                  <button
                    className={`${wsCreationcss.perviewBtn} mr-2`}
                    disabled={workspace.status === "cancelled"}
                    onClick={handleOpenModal1}
                    type="button" style={{ "padding": "7px" }}>{workspace.status === "cancelled" ? "Cancelled" : "Return"}
                  </button>
                }
                {workspace.status === "cancelled" ? "" :
                  <button
                    disabled={workspace.status === "approved"}
                    onClick={handleApprove} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>{workspace.status === "approved" ? "Approved" : "Approve"}</button>
                }
              </div>
            ) : (
              <div className={wsCreationcss.footerbtnContainer}>
                <span className={wsCreationcss.skipForNow}
                  onClick={skipNext} >Skip for now</span>
                <button
                  className={wsCreationcss.perviewBtn} onClick={() => history.push(`/importPreset/${w_id[2]}`)}
                  type="button" style={{ "padding": "7px" }}><PervBtnIcon height={19} />Previous</button>
                <button onClick={nextStep} className={wsCreationcss.saveBtn} type="button" style={{ "padding": "7px" }}>Let’s Get Started!</button>

              </div>
            )}


          </div>
        </div>
      </div >
    </>
  );
};

export default InviteteamMember;

const SelectUser = (props) => {
  const { w_id, user, userAccess } = props;
  const [value, setValue] = useState("");
  const handleChange = async (event, a_id, email) => {
    setValue(event.target.value);

    let data = {
      access_user_id: a_id,
      email: email,
      access: event.target.value,
      workspace_id: w_id[2],
    };

    const res = await CreateAccess(data);
    if (res.status === 200) {
      console.log(res.data);
    }
  };
  // console.log(userAccess,"userAccessuserAccessuserAccess",user._id);
  // console.log(userAccess.filter((det)=>det.access_user_id === user._id),"0000000000000000000",user._id);
  return (
    <>
      <FormControl sx={{ minWidth: 160 }}>
        <Select
          value={value}
          onChange={(e) => handleChange(e, user._id, user.email)}
          displayEmpty
          inputProps={{ "aria-label": "Without label" }}
        >
          <MenuItem value="">
            <em className="font-sans">Selected..</em>
          </MenuItem>
          <MenuItem
            className="font-sans"
            value={"Edit"}
          // selected={userAccess.access === "Edit"}
          >
            Edit Access
          </MenuItem>
          <MenuItem
            className="font-sans"
            value={"Audit"}
          // selected={userAccess.access === "Audit"}
          >
            Audit Access
          </MenuItem>
          <MenuItem
            className="font-sans"
            value={"View"}
          // selected={userAccess.access === "View"}
          >
            View Access
          </MenuItem>
        </Select>
        {userAccess.user_id}
      </FormControl>
    </>
  );
};
